const name = "setting";
export default name;
